// extracted by mini-css-extract-plugin
export default {"bgWhite":"common_bgWhite__Czar5"};